module.exports = __webpack_public_path__ + "static/media/viber.091c6b70.png";